import { render, staticRenderFns } from "./Lottery.vue?vue&type=template&id=b24d8e38&scoped=true&"
import script from "./Lottery.vue?vue&type=script&lang=js&"
export * from "./Lottery.vue?vue&type=script&lang=js&"
import style0 from "./Lottery.vue?vue&type=style&index=0&id=b24d8e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24d8e38",
  null
  
)

export default component.exports